import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EA4335",
      d: "M7.041 10.494a5.43 5.43 0 0 1 5.169-3.727c1.297 0 2.47.46 3.39 1.215l2.68-2.68C16.647 3.88 14.554 3 12.21 3a9.19 9.19 0 0 0-8.258 5.104z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#34A853",
      d: "M15.31 16.824c-.837.54-1.899.828-3.1.828a5.43 5.43 0 0 1-5.16-3.702l-3.1 2.354a9.18 9.18 0 0 0 8.26 5.115c2.25 0 4.4-.8 6.012-2.302z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4A90E2",
      d: "M18.222 19.118C19.906 17.546 21 15.208 21 12.211c0-.545-.084-1.13-.209-1.675H12.21v3.56h4.939c-.243 1.196-.898 2.122-1.838 2.73z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FBBC05",
      d: "M7.05 13.948a5.5 5.5 0 0 1-.282-1.74c0-.6.095-1.177.274-1.716l-3.09-2.39A9.16 9.16 0 0 0 3 12.206c0 1.474.342 2.863.95 4.095z"
    }, null, -1)
  ])))
}
export default { render: render }